module.exports = __webpack_public_path__ + "static/images/styles/images/nations/japan.782b4330.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/nations/japan.png
// module id = 3668
// module chunks = 11